<template>
  <div id="app" @click='generateStrayClick'>
    <loader></loader>
    <modal></modal>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Modal from './components/shared/modal/Modal'
import Loader from './components/shared/loader/Loader'
import * as NameSpace from 'src/store/NameSpace'
import { MERCHANT_ROLE, EMAIL_SELECTED_BY_SUPERUSER, MERCHANT_SELECTED_BY_SUPERUSER } from 'src/constants/Constants'
import { isSuperUser } from 'src/components/shared/helper/superUser'

export default {
  name: 'app',
  computed: {
    ...mapGetters({
      authState: NameSpace.AUTH_GETTER,
      gettersLandingInfo: NameSpace.GET_LANDING_DATA,
      gettersAllEmails: NameSpace.GETTER_ALL_EMAILS
    }),
    sessionExpiry () {
      return this.authState.expired
    },
    auth () {
      return this.authState.auth
    },
    isMerchant () {
      if (this.auth && this.auth.user_group) {
        return this.checkAuthorize(this.auth.user_group)
      }
    },
    errorInitializingLandingData () {
      return this.gettersLandingInfo.error
    }
  },
  watch: {
    'gettersAllEmails.error' () {
      let error = this.gettersAllEmails.error
      if (error) {
        this.showError(error)
      }
    },
    errorInitializingLandingData () {
      this.showError(this.gettersLandingInfo.error)
    },
    auth () {
      if (this.isLogged()) {
        if (this.isMerchant) {
          if (isSuperUser()) {
            this.setEmail()
            this.getEmailsForSuperUser()
          }
          this.fetchLandingInfo()
        }
      }
    },
    sessionExpiry (n, o) {
      if (this.sessionExpiry === true) {
        this.$router.push({name: 'login'})
      }
    }
  },
  created () {
    if (this.isLogged()) {
      this.getUser()
      if (isSuperUser()) {
        this.setEmail()
      }
    }
  },
  methods: {
    ...mapActions({
      loader: NameSpace.LOADER_SHOW_ACTION,
      fetchLandingInfo: NameSpace.FETCH_LANDING_DATA,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION,
      getUser: NameSpace.GET_USER_FROM_LOCAL_STORAGE,
      getEmailsForSuperUser: NameSpace.ACTION_ALL_EMAILS,
      storeSelectedVendor: NameSpace.SET_EMAIL_SELECTED_BY_SUPERUSER,
      setSelectedMerchant: NameSpace.SET_SELECTED_MERCHANT
    }),
    generateStrayClick (e) {
      window.eventBus.$emit('strayClick', e)
    },
    checkAuthorize (userGroup) {
      // if (userGroup.indexOf(SUPER_USER_ROLE) !== -1) {
      //   return true
      // } else if (userGroup.indexOf(MERCHANT_ROLE) !== -1) {
      //   return true
      // } else {
      //   return false
      // }
      if (userGroup.indexOf(MERCHANT_ROLE) !== -1) {
        return true
      } else {
        return false
      }
    },
    isLogged () {
      if (JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser'))) {
        return true
      } else {
        return false
      }
    },
    showError (error) {
      this.pop({
        header: 'Request Failed',
        message: error,
        type: 'ERROR'
      })
    },
    setEmail () {
      let vendor = localStorage.getItem(EMAIL_SELECTED_BY_SUPERUSER)
      if (vendor) {
        vendor = JSON.parse(vendor)
        this.storeSelectedVendor(vendor)
      }
      // For merchants
      let merchant = localStorage.getItem(MERCHANT_SELECTED_BY_SUPERUSER)
      if (typeof merchant !== 'undefined') {
        merchant = JSON.parse(merchant)
        this.setSelectedMerchant(merchant)
      }
      return null
    }
  },
  components: {
    Modal,
    Loader
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// App.vue?57cf5fc0